import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OverlayState {
  originalScrollY: number;
  isOverlayOpen: boolean;
}

const initialState: OverlayState = {
  originalScrollY: 0,
  isOverlayOpen: false,
};

const overlaySlice = createSlice({
  name: "overlay",
  initialState,
  reducers: {
    setOriginalScrollY: (state, action: PayloadAction<number>) => {
      state.originalScrollY = action.payload;
    },
    setIsOverlayOpen: (state, action: PayloadAction<boolean>) => {
      state.isOverlayOpen = action.payload;
    },
  },
});

export const { setOriginalScrollY, setIsOverlayOpen } = overlaySlice.actions;

export default overlaySlice.reducer;
